export default "/images/garmin_connect_companion_app.webp"